// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_GRID_COPY_FILTER = "Skop\u00edrova\u0165 filter";
export const BAZAAR_GRID_COPY_FILTER_PROMPT = "Skop\u00edruj si obsah filtra";
export const BAZAAR_GRID_COPY_FILTER_SUCCESS = "Filter bol skop\u00edrovan\u00fd do clipboardu.";
export const BZ2_COMMERCIAL_FIRST = "Plus a PRO na za\u010diatku";
export const BZ2_counter_PRODUCTS = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1tov"];
export const BZ2_FILTER_SECTION_PRODUCTS_ALL = "V\u0161etky inzer\u00e1ty";
export const BZ2_FILTER_SECTION_PRODUCTS_FROM_LIKED_SELLERS = "Od mojich ob\u013e\u00faben\u00fdch";
export const BZ2_ONLY_NOT_MARKED = "Iba neskontrolovan\u00e9";
export const BZ2_ONLY_REPORTED = "Iba nahl\u00e1sen\u00e9";
export const BZ2_SEARCH_IN = "H\u013eadaj v";
export const BZ2_SEARCH_IN_ALL_AND_USERS = "H\u013eadaj inzer\u00e1ty (napr. \"tenisky Adidas\", \"Nitra ko\u010d\u00edk\") a predajcov (@loginpredajcu)";
